import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const CheckCircleIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "check-circle",
  "CheckCircleIcon",
  ["currentColor","white"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><g clipPath="url(#clip0_19498_533)"><path d="M8.00016 14C11.3139 14 14.0002 11.3137 14.0002 8.00004C14.0002 4.68633 11.3139 2.00004 8.00016 2.00004C4.68646 2.00004 2.00016 4.68633 2.00016 8.00004C2.00016 11.3137 4.68645 14 8.00016 14ZM15.3335 8.00004C15.3335 12.0501 12.0503 15.3334 8.00016 15.3334C3.95008 15.3334 0.66683 12.0501 0.666831 8.00004C0.666831 3.94995 3.95008 0.666707 8.00016 0.666707C12.0503 0.666708 15.3335 3.94995 15.3335 8.00004ZM7.3335 10.6095L4.72402 8.00004L5.66683 7.05723L7.3335 8.7239L10.6668 5.39057L11.6096 6.33337L7.3335 10.6095Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g><defs><clipPath id="clip0_19498_533"><rect width="16" height="16" fill={colorList[1]}/></clipPath></defs></g></svg>
);

export default CheckCircleIcon;
